import { render, staticRenderFns } from "./Ciudades.vue?vue&type=template&id=6c5fde6e&"
import script from "./Ciudades.vue?vue&type=script&lang=js&"
export * from "./Ciudades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports